import(/* webpackMode: "eager", webpackExports: ["ChildrenLayout"] */ "/tmp/seed/source/apps/web/app/(layouts)/default.client.layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/tmp/seed/source/apps/web/app/(normal)/clientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/tmp/seed/source/apps/web/app/(providers)/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrialBanner"] */ "/tmp/seed/source/apps/web/components/generic/TrialBanner/TrialBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/tmp/seed/source/apps/web/lib/theme.ts");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/styles/normalGlobals.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/@bprogress/core/dist/index.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/app/(layouts)/default.layout.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/components/generic/UnsupportedResolution/UnsupportedResolution.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Alert"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Alert/Alert.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Title/Title.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/tmp/seed/source/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/seed/source/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-mono\"}],\"variableName\":\"fontMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/tmp/seed/source/node_modules/nuqs/dist/adapters/next/app.js");
